import { useEffect, useState } from "react";
import UserProductService from "../../services/user/UserProductService";

export default function useUserProducts(filters) {
  const [products, setProducts] = useState([]);
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    totalPages: 1,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchProducts() {
      try {
        setLoading(true);
        const res = await UserProductService.getProducts(filters);

        if (!isMounted) return;

        setProducts(res.data.data.items || []);
        setMeta({
          total: res.data.data.total || 0,
          page: res.data.data.page || filters.page,
          totalPages: res.data.data.totalPages || 1,
        });
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchProducts();

    return () => {
      isMounted = false;
    };
  }, [filters]);

  return {
    products,
    meta,
    loading,
    error,
  };
}
